import { render, staticRenderFns } from "./AddGiftingRemindersCard.vue?vue&type=template&id=febdb8c0&scoped=true&"
import script from "./AddGiftingRemindersCard.vue?vue&type=script&lang=js&"
export * from "./AddGiftingRemindersCard.vue?vue&type=script&lang=js&"
import style0 from "./AddGiftingRemindersCard.vue?vue&type=style&index=0&id=febdb8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febdb8c0",
  null
  
)

export default component.exports